import heatMapProxy from '../../../proxies/market/HeatMapProxy';
import ServiceBase from '../../ServiceBase';
import { ChanelConfig } from './../../../../configs/GlobalConfig';

class HeatMapService extends ServiceBase {
  getHeatMap(params, source) {
    return this.processSubscription(data => {
      var res = [];
      for (var sector of data.items[0].sectors) {
        if (sector && sector.tickers) {
          for (var ticker of sector.tickers) {
            res.push(this.getSubscribtionChannel(ticker.organCode));
          }
        }
      }

      return res;
    })(() =>
      this.applyMemoryCache('HeatMapService.getHeatMap', params)(() =>
        heatMapProxy.getHeatMap(params, source),
      ),
    );
  }
}

const heatMapService = new HeatMapService();
export default heatMapService;
